export default __webpack_public_path__ + "static/media/wheel_2.f1cbd7e4.svg";